// @flow

import React from 'react';
import { connect } from 'react-redux';

import Sticky from 'react-sticky-el';

import { Hidden } from 'seek-style-guide/react';

import ApplyButton from '../JobApply/ApplyButton/ApplyButton';
import JobApplyMessage from '../JobApply/JobApplyMessage/JobApplyMessage';
import SaveJob from 'src/components/SaveJob/SaveJob';
import { get } from 'lodash';

import { getJobStatusFlags } from 'src/modules/job-status';

import styles from './StickyApplyMobile.less';

type StickyApplyMobileProps = {
  appliedDateUTC?: string,
  job: ChaliceJobDetail,
  savedJobs?: SavedJobs
};

const StickyApplyMobile = ({
  appliedDateUTC,
  job,
  savedJobs
}: StickyApplyMobileProps) => {
  const {
    isExpired,
    isLinkOut,
    isScreenAssigned,
    isSelectionCriteriaEnabled
  } = job;

  const { isApplied } = getJobStatusFlags({ savedJobs, jobId: job.id });

  return (
    !isExpired && (
      <Hidden desktop>
        <Sticky mode="bottom">
          <div className={styles.content}>
            <div className={styles.flex}>
              <ApplyButton />
              {!isApplied && (
                <SaveJob job={job} className={styles.stickySaveJob} />
              )}
            </div>
            <JobApplyMessage
              {...{
                appliedDateUTC,
                isOnStickyApply: true,
                isLinkOut,
                isScreenAssigned,
                isSelectionCriteriaEnabled
              }}
            />
          </div>
        </Sticky>
      </Hidden>
    )
  );
};

const mapStateToProps = ({ savedJobs, jobdetails }) => ({
  job: jobdetails.result,
  savedJobs: savedJobs && savedJobs.jobs,
  appliedDateUTC: get(jobdetails, 'jobApplication.appliedDateUTC')
});

export default connect(mapStateToProps)(StickyApplyMobile);
